import { render, staticRenderFns } from "./LibraryContentPanel.vue?vue&type=template&id=63e9ed04&scoped=true"
import script from "./LibraryContentPanel.vue?vue&type=script&lang=js"
export * from "./LibraryContentPanel.vue?vue&type=script&lang=js"
import style0 from "./LibraryContentPanel.vue?vue&type=style&index=0&id=63e9ed04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9ed04",
  null
  
)

export default component.exports